import { SET_WALLETCONNECT_URI, SET_ISCONNECT_WITH_WALLECT } from './action'

const initialState = {
  wcUri: '',
  isConnectedWithWallet: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_WALLETCONNECT_URI:
      return {
        ...state,
        wcUri: action.data,
      }

    case SET_ISCONNECT_WITH_WALLECT:
      return {
        ...state,
        isConnectedWithWallet: action.data,
      }

    default:
      return state
  }
}
